var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    {
      staticClass: "store-footer",
      attrs: { id: "store-footer", role: "contentinfo" }
    },
    [
      _c("div", { staticClass: "footer", class: _vm.style() }, [
        _c("div", { staticClass: "full-container bottom" }, [
          _c("img", {
            staticClass: "logo",
            attrs: {
              alt: "store logo image",
              src: require("../../assets/store-logo.png"),
              width: "95",
              "aria-label": "store logo"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "sections" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex-section section",
                attrs: { id: "social-section" }
              },
              [
                _c("h4", { staticClass: "section-title" }, [
                  _vm._v("Connect with us")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-group social-icon-container" },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "//www.facebook.com/brewedawakeningscoffeeroasters",
                          "aria-label": "Brewed Awakenings on Facebook",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [
                        _c("BaseIcon", {
                          attrs: {
                            classNames: ["social-icon"],
                            icon: "facebook",
                            size: "1x"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "//www.instagram.com/brewed_awakenings/",
                          "aria-label": "Brewed Awakenings on Instagram",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [
                        _c("BaseIcon", {
                          attrs: {
                            classNames: ["social-icon"],
                            icon: "instagram",
                            size: "1x"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "//twitter.com/BrewedRoasters",
                          "aria-label": "Brewed Awakenings on Twitter",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [
                        _c("BaseIcon", {
                          attrs: {
                            classNames: ["social-icon"],
                            icon: "twitter",
                            size: "1x"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(2)
        ])
      ]),
      _vm._v(" "),
      _c("tp-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-section section" }, [
      _c("h4", { staticClass: "section-title" }, [_vm._v("Site map")]),
      _vm._v(" "),
      _c("div", { staticClass: "section-group" }, [
        _c("a", { attrs: { href: "//brewedawakenings.us/" } }, [
          _vm._v("HOME")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "//brewedawakenings.us/menu" } }, [
          _vm._v("MENU")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "//brewedawakenings.us/about-us" } }, [
          _vm._v("ABOUT US")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "//brewedawakenings.us/locations" } }, [
          _vm._v("LOCATIONS")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "//brewedawakenings.us/roastery" } }, [
          _vm._v("ROASTERY")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "//brewedawakenings.us/employment" } }, [
          _vm._v("EMPLOYMENT")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-section section" }, [
      _c("h4", { staticClass: "section-title" }, [_vm._v("Contact us")]),
      _vm._v(" "),
      _c("div", { staticClass: "section-group" }, [
        _c("a", { attrs: { href: "//brewedawakenings.us/contact" } }, [
          _vm._v("GET IN TOUCH")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sections-bottom" }, [
      _c("div", { staticClass: "full-width" }, [
        _c("span", { staticClass: "highlight" }, [
          _vm._v(
            "Brewed Awakenings Coffee Roasters is a family owned business offering customers a local source for hand-roasted coffee and fresh baked goods. With seven locations spanning from the Vancouver/Portland area to Sunriver and Bend, Oregon, there's always an Awakenings just around the corner."
          ),
          _c("br")
        ]),
        _vm._v(
          "\n\t\t\t\t\t© COPYRIGHT BREWED AWAKENINGS COFFEE ROASTERS, ALL RIGHTS RESERVED\n\t\t\t\t"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d08a398", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d08a398","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/AppFooter.vue
// module id = null
// module chunks = 